var _circle, _circle2, _circle3, _circle4, _circle5, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgVendors = function SvgVendors(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 38.5,
    stroke: "#296379",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 8,
    r: 7.5,
    fill: "#fff",
    stroke: "#296379"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 82,
    r: 7.5,
    fill: "#fff",
    stroke: "#296379"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 45,
    r: 7.5,
    transform: "rotate(-180 8 45)",
    fill: "#fff",
    stroke: "#296379"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 45,
    r: 7.5,
    transform: "rotate(-180 82 45)",
    fill: "#fff",
    stroke: "#296379"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m55.431 51.504-9.99 5.767a.865.865 0 0 1-.878 0l-9.991-5.767a.877.877 0 0 1-.44-.763V39.218a.885.885 0 0 1 .44-.767l10.003-5.776a.882.882 0 0 1 .878 0l9.978 5.767a.885.885 0 0 1 .441.766V50.74a.876.876 0 0 1-.44.763ZM45 29a16 16 0 1 0 0 32 16 16 0 0 0 0-32",
    fill: "#296379"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.236 48.764c-.227-.022-.425-.067-.728-.099v-3.557h1.97c.412 0 .814 0 1.162.023v1.826c0 .47 0 1.277-.032 1.699-.217.041-.447.073-.686.108l-.02.32h6.157l.022-.32c-.23-.022-.425-.067-.728-.099v-3.557h1.967c.415 0 .817 0 1.166.023v1.826c0 .47 0 1.277-.032 1.699-.22.041-.447.073-.687.108l-.022.32h3.113l.019-.32c-.227-.022-.434-.067-.738-.099V43.03c0-.466 0-1.277.032-1.699l.706-.096.022-.319h-3.122l-.02.32.729.095v3.289h-1.948c-.415 0-.827 0-1.185-.023V43.03c0-.466 0-1.277.032-1.699l.696-.096.022-.319h-6.168l-.023.32.728.095v3.289h-1.947c-.412 0-.827 0-1.185-.023V43.03c0-.466 0-1.277.032-1.699l.696-.096.022-.319h-3.122v.32l.728.095v5.626c0 .47 0 1.277-.023 1.699-.217.041-.466.073-.705.108l-.023.32h3.11l.013-.32Zm4.058-.108V43.03c0-.466 0-1.277.023-1.699h1.388v5.626c0 .466 0 1.277-.022 1.696h-.638l-.75.003Z",
    fill: "#296379"
  })));
};

export default SvgVendors;